export const CLUSTER_PORTAL_ROLES = ["ECOSYSTEM_HEAD", "ECOSYSTEM_SUBHEAD"] as const;

export type ClusterPortalRole = (typeof CLUSTER_PORTAL_ROLES)[number];

export function isClusterPortalRole(role?: string | null): role is ClusterPortalRole {
  return role === "ECOSYSTEM_HEAD" || role === "ECOSYSTEM_SUBHEAD";
}

export function isClusterHeadRole(role?: string | null): boolean {
  return role === "ECOSYSTEM_HEAD";
}

export function isClusterSubheadRole(role?: string | null): boolean {
  return role === "ECOSYSTEM_SUBHEAD";
}
